<template>
  <path
    d="M21 10.0002C19.9 10.0002 19 10.9002 19 12.0002V15.0002H5V12.0002C5 10.9002 4.1 10.0002 3 10.0002C1.9 10.0002 1 10.9002 1 12.0002V17.0002C1 18.1002 1.9 19.0002 3 19.0002H21C22.1 19.0002 23 18.1002 23 17.0002V12.0002C23 10.9002 22.1 10.0002 21 10.0002ZM18 5.00018H6C4.9 5.00018 4 5.90018 4 7.00018V9.15018C5.16 9.56018 6 10.6602 6 11.9702V14.0002H18V11.9702C18 10.6702 18.84 9.57018 20 9.15018V7.00018C20 5.90018 19.1 5.00018 18 5.00018Z"
  />
</template>
